module.exports = __webpack_public_path__ + "tables/media/Arrow 5.d92daa82.svg";